import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

const FONT_B = "'Source Sans 3', sans-serif";

function getStrength(password) {
  let score = 0;
  if (password.length >= 8) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^a-zA-Z0-9]/.test(password)) score++;
  if (password.length >= 12) score++;
  return Math.min(score, 4);
}

const LABELS = ['', 'Weak', 'Fair', 'Good', 'Strong'];
const COLORS = ['#E0DECF', '#C0392B', '#B5760A', '#6B8E23', '#556B2F'];

export default function PasswordStrengthMeter({ password, confirmPassword, showChecklist = true }) {
  const strength = getStrength(password);
  const has8 = password.length >= 8;
  const hasNumberOrSymbol = /[0-9]/.test(password) || /[^a-zA-Z0-9]/.test(password);
  const passwordsMatch = confirmPassword !== undefined ? password === confirmPassword && password.length > 0 : true;

  const checks = [
    { label: 'At least 8 characters', met: has8 },
    { label: 'A number or a symbol', met: hasNumberOrSymbol },
  ];
  if (confirmPassword !== undefined) {
    checks.push({ label: 'Passwords match', met: passwordsMatch });
  }

  return (
    <div>
      {/* Strength meter */}
      {password.length > 0 && (
        <div style={{ marginBottom: showChecklist ? 12 : 0 }}>
          <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
            {[1, 2, 3, 4].map(i => (
              <div key={i} style={{
                flex: 1, height: 5, borderRadius: 999,
                background: i <= strength ? COLORS[strength] : '#E0DECF',
                transition: 'background .2s',
              }} />
            ))}
          </div>
          <div style={{ fontSize: 13, fontWeight: 600, color: COLORS[strength], fontFamily: FONT_B }}>
            {LABELS[strength]}
          </div>
        </div>
      )}

      {/* Checklist */}
      {showChecklist && (
        <div style={{ background: '#FBFBF3', borderRadius: 10, padding: '10px 14px' }}>
          {checks.map((c, i) => {
            const Icon = c.met ? CheckCircle2 : Circle;
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 14, fontFamily: FONT_B }}>
                <Icon size={16} color={c.met ? '#556B2F' : '#9AA088'} />
                <span style={{ color: c.met ? '#2C2F26' : '#9AA088' }}>{c.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export { getStrength };
